// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"App_wrapper__2an5o","content":"App_content__M6AU7"};